import React from 'react';
import { AlertTriangle } from 'lucide-react';
import type { TplAttentionEvent } from '../../../services/tplSituationalCockpit';
import { TPL_SEVERITY_STYLE } from '../../../services/tplSeverityStyles';

interface TplAttentionNowBlockProps {
  events: TplAttentionEvent[];
}

/** Top eventos que requerem atenção imediata — ordenados por impacto. */
export const TplAttentionNowBlock: React.FC<TplAttentionNowBlockProps> = ({ events = [] }) => (
  <section className="rounded-lg border border-slate-200 dark:border-slate-800">
    <div className="flex items-center gap-1.5 border-b border-slate-100 px-3 py-2 dark:border-slate-800">
      <AlertTriangle size={13} className="text-amber-500" />
      <h4 className="text-[10px] font-bold uppercase tracking-wide text-slate-700 dark:text-slate-200">
        O que requer atenção agora
      </h4>
    </div>
    {events.length === 0 ? (
      <p className="px-3 py-4 text-[11px] text-emerald-600 dark:text-emerald-400">
        Nenhuma exceção crítica no turno.
      </p>
    ) : (
      <ol className="divide-y divide-slate-100 dark:divide-slate-800">
        {events.map((event, i) => {
          const style = TPL_SEVERITY_STYLE[event.severity];
          return (
            <li key={event.id} className={`flex items-start gap-2 px-3 py-2 ${style.bg}`}>
              <span className="mt-0.5 w-4 shrink-0 text-[10px] font-bold tabular-nums text-slate-400">
                {i + 1}
              </span>
              <div className="min-w-0 flex-1">
                <p className="truncate text-[11px] font-semibold text-slate-800 dark:text-slate-100">
                  {event.subject}
                </p>
                <p className={`text-[10px] ${style.text}`}>{event.detail}</p>
              </div>
            </li>
          );
        })}
      </ol>
    )}
  </section>
);

export default TplAttentionNowBlock;
